import imga from '@/imgs/dynamica.png'
import imgb from '@/imgs/dynamicb.png'
import imgc from '@/imgs/dynamicc.png'
import imgd from '@/imgs/dynamicd.png'
import imge from '@/imgs/dynamice.png'
import imgf from '@/imgs/dynamicf.png'
import imgg from '@/imgs/dynamicg.png'
import imgh from '@/imgs/dynamich.png'
import imgi from '@/imgs/dynamich1.png'
import imgj from '@/imgs/dynamich2.png'
import imgk from '@/imgs/dynamici.png'
import imgl from '@/imgs/dynamicj.png'
import imgm from '@/imgs/dynamick.png'
import imgn from '@/imgs/dynamicl.png'
import imgo from '@/imgs/dynamicm.png'
import imgp from '@/imgs/dynamicn.png'
import imgq from '@/imgs/dynamico.png'
import imgr from '@/imgs/dynamicp.png'
import imgs from '@/imgs/dynamicq.png'
import imgt from '@/imgs/dynamicr.png'
import imgu from '@/imgs/dynamics.png'
import imgv from '@/imgs/dynamict.png'
import imgw from '@/imgs/dynamicu.png'
import imgx from '@/imgs/dynamicv.png'
import imgy from '@/imgs/dynamicw.png'
import imgz from '@/imgs/dynamicx.png'
import interone from '@/imgs/intersone.png'
import intertwo from '@/imgs/interstwo.png'
import interthree from '@/imgs/intersthree.png'
import interfour from '@/imgs/intersfour.png'
import interfive from '@/imgs/intersfive.png'
import intersix from '@/imgs/interssix.png'
import interseven from '@/imgs/intersseven.png'
import intereight from '@/imgs/interseight.png'
import internine from '@/imgs/intersnine.png'
import newbannerone from '@/imgs/newsbannerone.png'
import newsbannertwo from '@/imgs/newsbannertwo.png'
import newsbannerthree from '@/imgs/newsbannerthree.jpg'
import homeworldimg from '@/imgs/bannerword.png'
import pcmap from '@/imgs/pcmap.png'
export default {
  navs: [
    {text: '首页', jump: '/homeWeb'},
    {text: '核心业务', jump: '/intelligent'},
    {text: '企业新闻', jump: 'http://news.mintechai.com/'},
    {text: '关于我们', jump: '/aboutus'}
  ],
  leftnavs: {
    a: '全球战略布局',
    b: '投资方',
    c: '合作机构'
  },
  pchome: {
    homeone: {
      imgword: homeworldimg
    },
    hometwo: {
      a: '菲尼克斯',
      b: '圣迭戈',
      c: '华盛顿',
      d: '北京',
      e: '扬州',
      f: '上海',
      g: '深圳',
      h: '马尼拉',
      i: '雅加达',
      j: '全球战略布局',
      k: 'Global Footprint',
      imgurl: pcmap

    },
    homethree: {
      a: '投资方介绍',
      b: 'Shareholders',
      redtext: '红点创投是1999年创办于美国的投资机构，也是最早进入中国的风险投资机构之一，在全球累计投资382家公司，其中121家完成上市或被并购，现在管理的资金规模达34亿美元。投资案例包括：Netflix、奇虎360、乐逗游戏、APUS等。',
      gaodetext: '高德是中国领先的数字地图内容、导航和位置服务解决方案提供商。公司2010年登陆美国纳斯达克全球精选市场，目前为阿里巴巴旗下子公司。2017年1月，MinTech获得由高德地图创始人成从武先生领投的B轮融资。',
      hongtaitext: '洪泰基金成立于2014年11月26日，由著名教育学家俞敏洪先生和资深投资银行家盛希泰先生（前华泰联合证券公司董事长）共同发起设立，是目前国内最大的单只人民币天使基金，资金规模为2亿元人民币。投资案例包括：51信用卡、橘子娱乐等。'
    },
    homefour: {

    }
  },
  inteligent: {
    partone: {
      title: '智能量子引擎',
      intro: '志在将数据驱动、科学运营理念贯穿于金融业务的每一环节',
      partlist: [
        {
          imgurl: interone,
          name: '变量引擎',
          text: '用互联网大数据及统计学建模的整合型技术，记录和分析用户的各项数据和行为轨迹，同时采用心理学方法，挖掘潜在需求，为金融机构实现低成本、高效率的获客，促使获客规模成几何量级增长。'
        },
        {
          imgurl: intertwo,
          name: '定量引擎',
          text: '自主研发的定量引擎已获专利认证，通过线上画像识别、多维度用户数据建模、精准分析、A/B Test 快速验证和迭代模型，并引入人工智能做到策略的自动优化，打造多重风控体系，从而实现毫秒风险核定。'
        },
        {
          imgurl: interthree,
          name: '筹量引擎',
          text: '利用多维度智能化实时匹配技术进行借贷双方以合规为核心的价格及风险精确匹配，从而达到资金使用效率最大化。'
        },
        {
          imgurl: interfour,
          name: '盘量引擎',
          text: '基于丰富的实战经验及回馈数据，多维度分析客户信息，打造量身定制的贷后模型，从而实现智能监控和立体化贷后预演，并根据用户行为反馈及时调整策略，进而确保资金合规、高效回收。'
        }
      ]
    },
    parttwo: {
      title: '区块链生态体系',
      intro: '2015 年，MinTech 在区块链技术领域开始战略性布局，逐步打造了集通证经济研究所、孵化加速器、商业创新咨询等业务于一体的区块链生态体系，构建了立体化的技术支撑和生态扶持架构，从技术、资金、资源等多方面推动区块链的行业发展和技术落地。',
      smarttitle: '三大优势',
      partlist: [
        {
          imgurl: interseven,
          name: '技术实力',
          text: '具有多项在共识算法、智能合约、原生多链等领域的独创技术，寻求突破不可能的三角魔咒，将区块链应用推向新高度。'
        },
        {
          imgurl: intersix,
          name: '金融底蕴',
          text: '多年的互联网金融实践经验，推动区块链技术渗透至数字钱包、支付、贷款、衍生品、积分、金融业 KYC 等金融应用场景。'
        },
        {
          imgurl: interfive,
          name: '全方位服务',
          text: '为有币改和链改意愿的企业提供通证模型设计、区块链技术、行业资源等全方位的扶助。把金融能力赋能给商业，帮助各种商业组织进行币改和链改，其核心价值在于降低价值转移的成本。'
        }
      ]
    },
    partthree: {
      title: '小桔猫',
      intro: '小桔猫是集互联网生活方式、消费新生态、生活便捷服务、大众金融服务于一体的智能消费服务平台，致力于为用户提供多维度、便捷美好的生活方式及个性化优质服务。',
      smarttitle: '一站式智能消费服务平台',
      partlist: [
        {
          name: '服务对象：',
          text: '新生代消费用户'
        },
        {
          name: '服务项目：',
          text: '零售电商、社区论坛、公积金查询、信用卡代办、信用卡代偿等丰富功能。'
        },
        {
          name: '技术优势：',
          text: '立足于发展普惠科技，打通线上线下全域消费场景，利用大数据、人工智能等科技手段，打造“社群 + 消费”的新一代移动互联网生活模式。'
        }
      ]
    },
    partfour: {
      title: '文资明特投资基金',
      intro: '发起人：MinTech、北京文资数码投资',
      partlist: [
        {
          imgurl: intereight,
          name: '投资方向',
          text: '捕捉以人工智能、机器深度学习、大数据平台技术、智能风控、智能征信平台、智能数字化投资平台、场景式金融信息平台、创新保险服务、创新金融资产服务平台等为核心驱动的前沿金融科技企业，以“投资 + 产业”结合的方式关注并追求长期的价值投资回报，同时推动企业较快的实现资本市场参与计划。'
        },
        {
          imgurl: internine,
          name: '投资领域',
          text: '基金将主要投资于泛金融、金融科技、TMT 等行业具有商业模式与技术创新的优质企业，并关注消费互联网及 IT 领域的早期投资机会。其中，80% 投资主要集中于 A 轮项目。'
        }
      ]
    }
  },
  newsbanner: ['/newst', '/newsw', '/newsd'],
  bannerList: [newbannerone, newsbannertwo, newsbannerthree],
  newslist: [
    {
      imgurl: imgx,
      title: 'MinTech全新品牌升级 用科技重新定义自己',
      content: '9月6日，MinTech在上海成功举办了主题为“创聚变·构未来”——2018品牌升级发布会，首次公布公司五大业务布局和全新品牌形象。',
      timeone: '9月6日',
      timetwo: '2018年',
      origin: '中国网',
      jump: '/newst'
    },
    {
      imgurl: imgy,
      title: '文资明特投资基金成立 重点扶持金融科技初创企业',
      content: '9月6日，MinTech在品牌升级发布会上正式宣布，联手北京文资数码投资成立文资明特投资基金。',
      timeone: '9月6日',
      timetwo: '2018年',
      origin: '中华网',
      jump: '/newsu'
    },
    {
      imgurl: imgz,
      title: 'MinTech与诺华诚信达成战略合作 推进“珠三角征信一体化”',
      content: '9月6日，MinTech联合创始人兼CEO李英浩与诺华诚信CEO何佳意正式签订战略合作协议。',
      timeone: '9月6日',
      timetwo: '2018年',
      origin: '财经网',
      jump: '/newsv'
    },
    {
      imgurl: imgu,
      title: '明特量化当选中国互联网金融协会会员单位',
      content: '未来，明特量化将严格遵守中国互金协会章程，高度自律并推动行业他律与互律，稳固自身发展根基。',
      timeone: '7月30日',
      timetwo: '2018年',
      origin: '财经网',
      jump: '/newsw'
    },
    {
      imgurl: imgt,
      title: '明特量化获评“2018新金融年度优秀企业十强”',
      content: '在整个金融领域留存当中，科技能够渗透在任何一个环节，而任何一个小领域的突破，都能带来整个用户服务的增加，从而提升整个企业和行业的效率。',
      timeone: '7月4日',
      timetwo: '2018年',
      origin: '凤凰网',
      jump: '/newsx'
    },
    {
      imgurl: imgv,
      title: '明特量化李英浩：抢占人工智能高地 新金融迎来弯道超车',
      content: '李英浩介绍到，明特量化做了诸多研究和实践，并在美国成立了智能网络信贷技术研发中心',
      timeone: '5月22日',
      timetwo: '2018年',
      origin: '财经网',
      jump: '/newsy'
    },
    {
      imgurl: imgw,
      title: '出席青腾汇博鳌饭局 明特量化赵亮：金融科技企业将大有可为',
      content: '本次饭局邀请到22位大咖参加，不仅汇聚了格力董明珠，福耀玻璃曹德旺、广药集团李楚源、明特量化董事长赵亮、迅雷CEO陈磊、美图创始人吴欣鸿等优秀企业家，同时还吸引了知名演员刘涛、佟大为，可谓星光熠熠。',
      timeone: '4月13日',
      timetwo: '2018年',
      origin: '中文网',
      jump: '/newsz'
    },
    {
      imgurl: imga,
      title: '明特量化荣获“ 2018年互联网金融行业影响力品牌”大奖',
      content: '两年来，明特量化得到了市场与口碑的双认可，横扫各大领奖台。',
      timeone: '3月21日',
      timetwo: '2018年',
      origin: '财经网',
      jump: '/newsa'
    },
    {
      imgurl: imgb,
      title: '明特量化：大数据和算法是金融创新的底层技术',
      content: '如果给金融科技一个形象，它像一个野心勃勃的机器人，拥有摧枯拉朽的力量，所到之处无往不利。',
      timeone: '2月28日',
      timetwo: '2018年',
      origin: '中国网',
      jump: '/newsb'
    },
    {
      imgurl: imgc,
      title: '明特量化李英浩荣膺“2018胡润新金融年度风云人物',
      content: '鉴于明特量化在资本、科研、管理、责任方面为新金融行业开疆拓土所取得的显著成绩，其联合创始人兼CEO李英浩被授予“2018胡润新金融行业年度风云人物”荣誉称号。',
      timeone: '1月20日',
      timetwo: '2018年',
      origin: '中国网',
      jump: '/newsc'
    },
    {
      imgurl: imgd,
      title: '《2017金融科技年度发展报告》出炉：明特量化等受关注',
      content: '金融科技带有强烈的技术特征，随着技术手段的日新月异，“金融科技”的内涵也将愈加丰富。',
      timeone: '1月15日',
      timetwo: '2018年',
      origin: '中华网',
      jump: '/newsd'
    },
    {
      imgurl: imge,
      title: '明特量化斩获“年度最具发展力机构奖”',
      content: '明特量化与蚂蚁金服、京东金融、国美金融、众安保险等多家行业领先机构共获年度新金融大奖。',
      timeone: '1月8日',
      timetwo: '2018年',
      origin: '财经网',
      jump: '/newse'
    },
    {
      imgurl: imgf,
      title: '明特量化等60家金融机构发起践行“责任金融”联合倡议',
      content: '明特量化等近60多家机构共同发起“践行责任金融联合倡议”，倡议所有从事金融业务的机构，肩负自身责任，共同构建负责任的金融体系，推动行业稳定健康发展。',
      timeone: '12月27日',
      timetwo: '2017年',
      origin: '百家号',
      jump: '/newsf'
    },
    {
      imgurl: imgg,
      title: '2017年云栖大会召开  明特量化成阿里云客户案例受关注',
      content: '“智能量子引擎”系统亮相云栖大会，因其在云端计算和云端安全方面的优秀表现，和南京银行、聚美优品等品牌一起被阿里云作为在金融场景中运用中的杰出客户案例。',
      timeone: '12月22日',
      timetwo: '2017年',
      origin: '中国经济网',
      jump: '/newsg'
    },
    {
      imgurl: imgk,
      title: '2017“金i奖”揭晓：明特量化荣获“2017年度金融科技卓越贡献奖”',
      content: '明特量化CDO袁成伟受邀出席论坛，并发表题为“金融科技实现普惠金融的技术与艺术”的主题演讲。',
      timeone: '12月21日',
      timetwo: '2017年',
      origin: '财经网',
      jump: '/newsh'
    },
    {
      imgurl: imgh,
      title: '每经“金鼎奖”得主明特量化：深耕金融科技不忘初心。',
      content: '这是对明特量化在金融科技创新、风险控制能力、团队管理能力以及企业责任感等多项能力的全面认可和权威认证。',
      timeone: '12月21日',
      timetwo: '2017年',
      origin: '财经网',
      jump: '/newsi'
    },
    {
      imgurl: imgj,
      title: '权威评选：明特量化荣获“2016-2017年度中国卓越金融奖”',
      content: '明特量化CEO李英浩认为，我国消费信贷市场发展迅速且潜力巨大。',
      timeone: '12月12日',
      timetwo: '2017年',
      origin: '中国网',
      jump: '/newsj'
    },

    {
      imgurl: imgi,
      title: '明特量化被授予“年度金融科技领军企业”奖',
      content: '明特量化凭借自主研发的智能量子引擎系统，搭建了完善的用户数据安全、反欺诈系统，在金融消费者权益保护方面取得了突出成就。',
      timeone: '12月11日',
      timetwo: '2017年',
      origin: '财经网',
      jump: '/newsk'
    },
    {
      imgurl: imgm,
      title: '明特量化荣获“2017年度中国互联网金融行业最佳研发团队奖”',
      content: '互联网企业能否长远的高速发展，关键还是核心竞争力的建设。',
      timeone: '12月8日',
      timetwo: '2017年',
      origin: '金融界',
      jump: '/newsl'
    },
    {
      imgurl: imgl,
      title: '下一个独角兽  明特量化跻身2017小饭桌新锐创业公司榜',
      content: '“2017最具成长性新锐创业公司榜”作为此次大会的重头戏，旨在从各个细分领域发掘最具潜力的创业公司和未来独角兽。',
      timeone: '12月8日',
      timetwo: '2017年',
      origin: '搜狐财经',
      jump: '/newsm'
    },
    {
      imgurl: imgn,
      title: '《2017年中国消费信贷市场发展报告》出炉  明特量化“智能量子引擎”系统受关注',
      content: '《2017年中国消费信贷市场发展报告》从多个维度，解读行业发展现状和趋势。',
      timeone: '12月7日',
      timetwo: '2017年',
      origin: '中国经营网',
      jump: '/newsn'
    },
    {
      imgurl: imgo,
      title: '智能量子引擎受关注  明特量化获评“最佳金融科技创业公司',
      content: '“最佳金融科技创业公司价值企业”奖正是对具有金融科技高度创新能力企业的肯定。',
      timeone: '11月30日',
      timetwo: '2017年',
      origin: '搜狐',
      jump: '/newso'
    },
    {
      imgurl: imgp,
      title: '金融科技技术安全共同体发力  明特量化等企业共筑信息安全防线',
      content: '明特量化CTO邵栋辉应邀出席金融科技技术安全共同体第一次成员大会。',
      timeone: '11月29日',
      timetwo: '2017年',
      origin: '环球网',
      jump: '/newsp'
    },
    {
      imgurl: imgq,
      title: '明特量化荣膺“年度金融科技最具成长价值企业”奖 ',
      content: '金融科技新技术正带来一种超乎想象的变革，在未来金融业应用中成为常态。',
      timeone: '11月26日',
      timetwo: '2017年',
      origin: '环球网',
      jump: '/newsq'
    },
    {
      imgurl: imgr,
      title: '权威评选：明特量化荣获“2017卓越竞争力人工智能先锋企业”',
      content: '中国经营报认为，中国已经成为世界第二大经济体，中国金融业肩负着重要使命。',
      timeone: '11月23日',
      timetwo: '2017年',
      origin: '搜狐',
      jump: '/newsr'
    },
    {
      imgurl: imgs,
      title: '明特量化李英浩：中国在线信贷商业模式可复制到海外',
      content: '2017年，科技开始渗透在大数据、人工智能、区块链等金融领域，每一项新技术都搅动着行业浪潮。',
      timeone: '9月4日',
      timetwo: '2017年',
      origin: '百家号',
      jump: '/newss'
    }
  ],
  companyNews: {
    a: '推荐内容',
    b: '媒体合作',
    c: '来源'

  },
  joinus: {
    title: '加入我们'
  },
  aboutus: {
    bannertext: {
      a: 'MinTech',
      b: 'MinTech 是金融科技领域的领军企业。旗下拥有“海外业务、智能量子引擎、区块链生态体系、小桔猫智能消费服务平台、文资明特投资基金”五大核心业务，目前已在中国、北美、东南亚等地区广泛落地，全球员工 700 余人。2016 年获美国红点创投、洪泰基金的 A 轮融资；2017 年获高德地图创始人领投、红点创投跟投的 B 轮融资。',
      c: '在“一带一路 ”的国家战略指引下，MinTech 始终践行科技赋能，依托人工智能、区块链、云计算、大数据等新一代科技技术，携手金融机构合作伙伴，实现为全球多个国家的数亿用户持续创造金融价值的发展愿景。'
      // d: ''
    },
    bossinfo: {
      one: {
        a: '李英浩',
        b: '联合创始人兼CEO',
        c: '美国佐治亚大学硕士',
        d: '康奈尔大学MBA',
        e: '曾任Capital One数据科学家、花旗集团全球风险总部高级副总裁、广发银行总行行长助理、纳斯达克上市公司融360首席风险官，拥有近20年国内外金融行业经验。',
        f: '自2013年起任中国人民大学客座教授，2017年起任五道口金融学院客座讲师。2018年，荣获“胡润新金融年度风云人物”。'
      },
      two: {
        a: '赵亮',
        b: '联合创始人兼董事长',
        c: '南京大学理科强化班本科',
        d: '美国迈阿密大学工程学硕士、博士学位',
        e: '任Capital One金融产品经理一职，主导6000万客户的产品设计和营销。任Credit Suisse投资银行总部要职，多次参与新兴市场超数十亿美金的投资项目。',
        f: '2007年创立美国量子信息公司，2010年创立NeoSource。亚杰商会学员、清华-青腾未来科技学堂一期学员。'
      },
      three: {
        a: '刘轶',
        b: '联合创始人兼COO',
        c: '美国宾夕法尼亚大学经济学博士候选人',
        d: '五道口金融学院国际金融硕士',
        e: '先后就职于中国人民银行总行、美国华盛顿国际货币基金组织。后加入Capital One任职十年，曾主导并购汇丰银行北美地区信用卡业务。',
        f: '拥有二十年个人金融和信贷领域实战经历，有着丰富的产品运营和金融IT项目经验。'
      },
      four: {
        a: 'Glenn Quiro',
        b: '国际业务副主席',
        c: '美国加州大学洛杉矶分校电子工程学士',
        d: '曾在美国伽利略技术公司、Altera公司和硅谷赛普拉斯半导体公司担任高管。后加入英特尔，14年间曾任中国大区产品总监，负责制定中国大区产品规划、产品线策略和产品推广支持等业务。同时兼任英特尔深圳和英特尔上海总经理。',
        e: '目前，负责MinTech国际化业务的拓展，促成团队和产品的本土化落地。'
      },
      five: {
        a: '粘旻环',
        b: '首席风险官',
        c: '美国克莱姆森大学应用经济学博士',
        d: '厦门大学经济学学士',
        e: '曾任Capital One消费信贷科学决策与支付部门高级总监，主导风控模型建设、风控策略上线及效果评估。同时负责定义产品前景、管理跨功能团队，把控各类大数据风控产品。曾三次获Capital One CEO大奖，并被聘为模型风险官。',
        f: '回国后，曾任趣店集团CRO、量化派COO。目前负责MinTech全球风控和分析团队的管理工作。'
      }
    },
    bossintr: '高管介绍',
    history: '发展历程',
    historyText: {
      aa: '2015年10月',
      a: '明特量化中国总部成立',
      bb: '2015年12月',
      b: '明特量化美国研发实验室成立',
      cc: '2016年5月',
      c: '明特量化获A轮融资',
      dd: '2017年1月',
      d: '明特量化获B轮融资',
      ee: '2017年7月',
      e: '明特量化印尼分公司成立',
      ff: '2017年12月',
      f: '明特量化菲律宾分公司成立',
      gg: '2018年9月',
      g: 'MinTech品牌升级'
    },
    honor: '企业荣誉',
    trophy: {
      a: '最佳大数据风控案例',
      aa: '--一本财经',
      b: '2018年互联网金融行业影响力品牌',
      bb: '--消费日报',
      c: '新金融行业年度风云人物 ',
      cc: '--2018胡润新金融百强榜',
      d: '2017年度最具发展力机构奖',
      dd: '--2017中国最具影响力新金融榜单',
      e: '2017金鼎奖年度优秀科技金融公司',
      ee: '--每日经济新闻',
      f: '2017卓越竞争力人工智能先锋企业奖',
      ff: '--中国经营报',
      g: '2016-2017年度中国卓越金融奖',
      gg: '--经济观察报',
      h: '2017年度互联网金融新势力奖',
      hh: '--百度金融峰会',
      i: '2017小饭桌新锐创业公司',
      ii: '--小饭桌',
      j: '最佳科技金融创业公司',
      jj: '--猎云网',
      k: '2017年度金融科技最具成长价值企业',
      kk: '--CEO领袖年会组委会',
      l: '2017年度中国互联网金融行业最佳研发团队奖',
      ll: '--赛迪',
      m: '践行责任金融联合倡议',
      mm: '--金融城',
      n: '年度金融科技领军企业',
      nn: '--中国消费者报',
      o: '2017年度金融科技卓越贡献奖',
      oo: '--互联网周刊',
      p: '共同体成员单位',
      pp: '--金融科技技术安全共同体',
      q: '2017年度消费金融风控平台奖',
      qq: '--融之家',
      r: '摇篮计划-亚洲之星',
      rr: '--亚洲商会',
      s: '中关村高新技术企业',
      ss: '--中关村科技园管理委员会',
      t: '北京市新技术新产品（服务）证书',
      tt: '--中关村科技园区管理委员会'
    }
  },
  footer: {
    a: '加入我们',
    b: '媒体采访邮箱：pr@mintechai.com',
    c: '商务合作邮箱：bd_marketing@mintechai.com',
    d: 'Copyright©2019北京铭泰金科信息技术有限公司 | 京ICP备18045888号',
    e: '友情链接：',
    f: '红点中国'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js